import React, { lazy, Suspense, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";
import { AlertPopup, Button, Icon, Input } from "@diemmea/dma-design-system";
import Fallback from "../Fallback";
import { useTranslation } from "react-i18next";
import "./index.css";
import Navbar from "../../components/Navbar";
import SettingsRouter from "./Settings";
import UpgradeModal from "../../components/UpgradeModal";
import { BRAND } from "../../services/brand";



const PrivateLayout = (props: any) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="flex justify-between flex-col" style={{ minHeight: "100vh" }}>
      <Navbar />
      <div className="w-full" style={{ minHeight: `calc(100vh - 56px - 64px)`, paddingBottom: location?.pathname?.startsWith("/settings") ? 0 : 100 }}>
        <Outlet />
      </div>
      <div className="bg-secondaryDark h-16">
        <div className="container  mx-auto flex w-full h-full items-center md:justify-between justify-center">
          <span className="text-white text-sm md:block hidden">©{new Date().getFullYear()} {BRAND.name}. All rights reserved</span>
          <span className="text-white text-sm">© Credits: <a className="text-primary" href="https://www.dma.it/" target={"_blank"}>dma.it</a></span>
        </div>
      </div>

      <UpgradeModal />

    </div>
  );
};

function Private() {
  const NotFound = lazy(() => import("./../NotFound"));
  const InstallationRouter = lazy(() => import("./Installation/router"));

  return (
    <Routes>
      <Route element={<PrivateLayout />}>
        <Route
          index
          element={
            <Suspense fallback={<Fallback />}>
              <InstallationRouter />
            </Suspense>
          }
        />

        {/* Installation */}
        <Route
          path="installations/*"
          element={
            <Suspense fallback={<Fallback />}>
              <InstallationRouter />
            </Suspense>
          }
        />

        {/* Settings */}
        <Route
          path="settings/*"
          element={
            <Suspense fallback={<Fallback />}>
              <SettingsRouter />
            </Suspense>
          }
        />

        <Route
          path="*"
          element={
            <Suspense fallback={<Fallback />}>
              <NotFound />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
export default Private;
